export const enum SubscriptionStatus {
  init = "init",
  connected = "connected",
  closed = "closed",
  connecting = "connecting",
  refetching = "refetching",
  timeout = "timeout",
}
